import { useSelector } from 'react-redux'
import { LoginResponse } from 'mvppoker-portal-common/api'
import { RootState } from '../AppStore'

export const useIsLoggedIn = (): boolean => {
	const user = useSelector((root: RootState) => root.activeUser.user)
	return user !== undefined
}

export const useActiveUser = (): LoginResponse | undefined => {
	const user = useSelector((root: RootState) => root.activeUser)
	if (user.user !== undefined) {
		return user as LoginResponse
	}
}

export const useActiveUserId = (): string | undefined => {
	return useSelector((root: RootState) => root.activeUser.user?.id)
}
